module.exports = __webpack_public_path__ + "img/重庆铜梁安居国家湿地公园@2x.f6a2444d.png";